<div class="modal-header">
  Tier for offer: {{ offerName }}
  <span
    type="button"
    class="close btn"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    &times;
  </span>
</div>
<div class="modal-body">
  <apt-tiers-detail #tiersDetail 
    [displayAttainability]="displayAttainability" 
    [displayOptimized]="displayOptimized" 
    [tiers]="tiers" 
    [tierSelected]="tierSelected"
    [tierDetailSettings]="tierDetailSettings"
  ></apt-tiers-detail>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      (click)="activeModal.close(tiersDetail.value)"
      [disabled]="(tiersDetail.value === null || tiersDetail.value === tierSelected) || !canChangeTier"
    >
      Apply Changes
    </button>
  </div>
</div>
